import {request} from "@/shared/api/http";
import {IGenerateInvoice, IGenerateInvoiceResult, Order} from "../model";

export async function getActiveOrder (uin: string): Promise<Order> {
    return (await request.get(`/proxy/ismet-docs-api.ismet-docs/api/v1/order/active/${uin}`)).data;
}

export const getOrders = async (uin: string): Promise<Order[]> => {
    return (await request.get(`/proxy/ismet-docs-api.ismet-docs/api/v1/order/${uin}`)).data;
}

export const getStatus = async (hash: string | undefined) => {
    return (await request.get(`/proxy/prebill-api.prebill/api/v1/result/${hash}`)).data;
}

export interface ICreateOrderAddress {
    address: string;
    num: number;
    subNum?: number | null;
}

export const createOrder = async (
    tariff: string,
    uin: string | undefined,
    checkPaid: boolean = false,
    address: ICreateOrderAddress | null = null,
    referralCode?: string,
) => {
    let params = new URLSearchParams()
    params.append('checkPaid', String(checkPaid));
    const body: Record<string, unknown> = address ? {...address} : {};
    if (referralCode) body.referralCode = referralCode;
    return (await request.post(`/proxy/ismet-docs-api.ismet-docs/api/v1/order/create-order/${uin}/${tariff}`, body, {params: params})).data;
}

export const getBalance = async (filialId: number | string, customerAccountId: number | string) => {
    return (await request.get(`/proxy/prebill-api.prebill/api/v1/helper/balance/by-filial_id-customer_account_id/${filialId}/${customerAccountId}`)).data;
}

export const generateInvoiceForPayment = async (params: IGenerateInvoice): Promise<IGenerateInvoiceResult> => {
    return (await request.post(`/proxy/documents-interceptor.bpmn/api/v1/document/payment-invoice/generate?ismetDocs=true&ismetDocsTariff=${params.isMonth ? 1 : 2}`, {
        abonentId: params.localId,
        currency: 'kzt',
        uin: params.uin,
        lang: params.lang,
        filialId: params.filialId,
        customerAccountCategoryId: params.customerAccountCategoryId,
        balance: params.balance,
    })).data;
}

export const getPathInvoiceForPayment = async (id: number) => {
    const path = (await request.get(`/proxy/documents-interceptor.bpmn/api/v1/document/payment-invoice/generate-path/${id}`)).data;
    return `/proxy/documents-interceptor.bpmn/api/v1/document/payment-invoice/public/by-path?path=${path}&download=true`;
}
